<div class="c-content c-content--wrapper" [ngClass]="{'c-content--xxl':!vm.loading && !vm.requests?.length,'u-no-p@up-to-md':vm.loading || vm.requests?.length}"
        [ngStyle]="(vm.loading || !vm.requests?.length) && { 'min-height': '160px' }">

    <ng-container *ngIf="!vm.loading">
        <table-booking-requests *ngIf="vm.requests?.length" [requests]="vm.requests"></table-booking-requests>
        <p *ngIf="!vm.requests?.length" class="c-text c-text--gray c-text--center c-text--md@up-to-md c-text--lg u-ost-md@up-to-md u-osb-md@up-to-md">
            {{ 'Booking.Other.NoContent' | translate }}
        </p>
    </ng-container>

    <loader-overlay *ngIf="vm.loading"></loader-overlay>

</div>
